import type { NavItemType } from "@/components/application/app-navigation/config";
import {
	hasTelemetryRestrictedNav,
	type PermissionModules,
	type Role,
	shouldBlockBackofficeAccess,
} from "@/utils/permissions";

type CanFn = (module: PermissionModules, action: string) => boolean;

function isTelemetryNavItemVisible(item: NavItemType, can: CanFn): boolean {
	if (item.label === "Telemetria") {
		return true;
	}

	if (item.label === "Usuários") {
		return can("users", "view");
	}

	return false;
}

function isFormsNavItemVisible(item: NavItemType, can: CanFn): boolean {
	if (item.items && item.items.length > 0) {
		item.items = item.items.filter((subItem) => {
			if (subItem.label === "Perguntas") {
				return true;
			}

			if (subItem.label === "Lista") {
				return can("forms", "view");
			}

			return false;
		});
		return item.items.length > 0;
	}

	return can("forms", "view");
}

function isDefaultNavItemVisible(item: NavItemType, can: CanFn): boolean {
	if (item.label === "Dashboard" || item.label === "Vistorias") {
		return can("histories", "view");
	}

	if (item.label === "Veículos") {
		return can("vehicles", "view");
	}

	if (item.label === "Formulários") {
		return isFormsNavItemVisible(item, can);
	}

	if (item.label === "Usuários") {
		return can("users", "view");
	}

	return true;
}

function shouldShowNavItem(
	item: NavItemType,
	roles: Role[],
	can: CanFn
): boolean {
	if (shouldBlockBackofficeAccess(roles)) {
		return false;
	}

	if (hasTelemetryRestrictedNav(roles)) {
		return isTelemetryNavItemVisible(item, can);
	}

	return isDefaultNavItemVisible(item, can);
}

export function filterNavItemsByRole(
	items: NavItemType[],
	roles: Role[],
	can: CanFn
): NavItemType[] {
	return items.filter((item) => shouldShowNavItem(item, roles, can));
}
